var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import Logo from '@Assets/Pagito_Logo_white.svg';
import { Link } from "react-router-dom";
import { useActiveTab } from '../contexts/ActiveTabContext';
import { useAuth } from '../contexts/AuthContext';
var pages = [
    {
        title: 'Token manager',
        url: '/',
    },
    {
        title: 'Configuración',
        url: '/settings',
    },
];
var NavLink = function (_a) {
    var title = _a.title, url = _a.url, onClick = _a.onClick, isActive = _a.isActive;
    return (_jsx(MenuItem, __assign({ onClick: onClick }, { children: _jsx(Typography, __assign({ sx: { textAlign: 'center' } }, { children: _jsx(Link, __assign({ to: url, state: { logged: true }, style: {
                    backgroundColor: isActive ? 'blue' : 'transparent',
                    color: isActive ? 'white' : 'black',
                    padding: '10px',
                    textDecoration: 'none',
                } }, { children: title })) })) }), title));
};
function ResponsiveAppBar() {
    var _a = React.useState(null), anchorElNav = _a[0], setAnchorElNav = _a[1];
    var _b = React.useState(null), anchorElUser = _b[0], setAnchorElUser = _b[1];
    var _c = useActiveTab(), activeTab = _c.activeTab, setActiveTab = _c.setActiveTab;
    var logout = useAuth().logout;
    var settings = [
        {
            title: 'Cerrar sesión',
            onClick: function () {
                logout();
            },
        }
    ];
    var handleOpenNavMenu = function (event) {
        setAnchorElNav(event.currentTarget);
    };
    var handleOpenUserMenu = function (event) {
        setAnchorElUser(event.currentTarget);
    };
    var handleClickNavMenuClick = function (sectionName) {
        setActiveTab(sectionName);
        setAnchorElNav(null);
    };
    var handleCloseUserMenu = function () {
        setAnchorElUser(null);
    };
    return (_jsx(Box, { children: _jsx(AppBar, __assign({ position: "static" }, { children: _jsxs(Toolbar, __assign({ disableGutters: true, sx: { margin: '10px 40px' } }, { children: [_jsx(Box, { component: "img", 
                        // DONT SHOW IN MOBILE
                        display: { xs: 'none', md: 'block' }, height: "auto", width: "50px", alt: "Logo", src: Logo }), _jsx(Typography, __assign({ variant: "h6", noWrap: true, component: "a", href: "/", sx: {
                            mr: 2,
                            ml: 2,
                            display: { xs: 'none', md: 'flex' },
                            fontFamily: 'monospace',
                            fontWeight: 700,
                            letterSpacing: '.3rem',
                            color: 'inherit',
                            textDecoration: 'none',
                        } }, { children: "PAGITO" })), _jsxs(Box, __assign({ sx: { flexGrow: 1, display: { xs: 'flex', md: 'none' } } }, { children: [_jsx(IconButton, __assign({ size: "large", "aria-label": "account of current user", "aria-controls": "menu-appbar", "aria-haspopup": "true", onClick: handleOpenNavMenu, color: "inherit" }, { children: _jsx(MenuIcon, {}) })), _jsx(Menu, __assign({ id: "menu-appbar", anchorEl: anchorElNav, anchorOrigin: {
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }, keepMounted: true, transformOrigin: {
                                    vertical: 'top',
                                    horizontal: 'left',
                                }, open: Boolean(anchorElNav), onClose: function () { return setAnchorElNav(null); }, sx: { display: { xs: 'block', md: 'none' } } }, { children: pages.map(function (page) { return (_jsx(NavLink, { title: page.title, url: page.url, onClick: function () { return handleClickNavMenuClick(page.title); }, isActive: activeTab === page.title })); }) }))] })), _jsx(Box, { component: "img", display: {
                            xs: 'flex',
                            md: 'none',
                        }, mr: 2, height: "auto", width: "50px", alt: "Logo", src: Logo }), _jsx(Typography, __assign({ variant: "h6", noWrap: true, component: "a", href: "#app-bar-with-responsive-menu", sx: {
                            mr: 2,
                            display: { xs: 'flex', md: 'none' },
                            flexGrow: 1,
                            fontFamily: 'monospace',
                            fontWeight: 700,
                            letterSpacing: '.3rem',
                            color: 'inherit',
                            textDecoration: 'none',
                        } }, { children: "PAGITO" })), _jsx(Box, __assign({ sx: { flexGrow: 1, display: { xs: 'none', md: 'flex' }, justifyContent: 'end', marginRight: '16px' } }, { children: pages.map(function (page) { return (_jsx(Button, __assign({ onClick: function () { return handleClickNavMenuClick(page.title); }, sx: { my: 2, color: 'white', display: 'block' } }, { children: _jsx(Link, __assign({ to: page.url, state: { logged: true }, style: { textDecoration: 'none', color: 'inherit' } }, { children: page.title })) }), page.title)); }) })), _jsxs(Box, __assign({ sx: { flexGrow: 0 } }, { children: [_jsx(Tooltip, __assign({ title: "Mi usuario" }, { children: _jsx(IconButton, __assign({ onClick: handleOpenUserMenu, sx: { p: 0 } }, { children: _jsx(Avatar, { alt: "Admin", src: "/static/images/avatar/2.jpg" }) })) })), _jsx(Menu, __assign({ sx: { mt: '45px' }, id: "menu-appbar", anchorEl: anchorElUser, anchorOrigin: {
                                    vertical: 'top',
                                    horizontal: 'right',
                                }, keepMounted: true, transformOrigin: {
                                    vertical: 'top',
                                    horizontal: 'right',
                                }, open: Boolean(anchorElUser), onClose: handleCloseUserMenu }, { children: settings.map(function (setting) { return (_jsx(MenuItem, __assign({ onClick: setting.onClick }, { children: _jsx(Typography, __assign({ sx: { textAlign: 'center' } }, { children: setting.title })) }), setting.title)); }) }))] }))] })) })) }));
}
export default ResponsiveAppBar;
